import showJSDConfirmPayDialog from '../components/jsdConfirm/jsdConfirmPayDialog';

type PayRes = {
  /**
   * 200 =>成功
   * 300 =>等待
   * 500 =>失败
   */
  code: number;
  msg: string;
  url?: string;
};

export default async function showPayPage(data: any, payType: string) {
  if (payType === PayType.gatherPayJsWechat || payType === PayType.WECHATJSPAY || payType === PayType.gmeJsPay) {
    return wechatJsPay(data);
  } else if (payType === PayType.ALIPAY) {
    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.payParam,
    };
  } else if (payType === PayType.JSDH5WX) {
    let res = await showJSDConfirmPayDialog({
      miniOrgId: data.miniOrgId,
      miniPath: data.miniPath,
      miliPaLink: data.miniPayLink,
    });
    if (res === 2) {
      return { code: 500, msg: '小程序跳转失败' };
    } else if (res === 1) {
      return { code: 400, msg: '是否支付完成' };
    } else {
      return { code: 500, msg: '取消支付' };
    }
  } else if (payType === PayType.JSDH5ALI) {

    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.payParam,
    };
  } else if (payType === PayType.LFT) {
    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.codeUrl,
    };
  } else if (payType === PayType.YHALIWEB || payType === PayType.YHWXWEB) {
    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.codeUrl,
    };
  }
  return {
    code: 500,
    msg: '暂不支持该支付方式',
  };
}

function wechatJsPay(data: any) {
  return new Promise<PayRes>((resolve, reject) => {
    // @ts-ignore
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: data.appId, //动态获取初始化请求中返回的pay_info参数中appId值
        timeStamp: data.timeStamp, //动态获取初始化请求中返回的pay_info参数中timeStamp值
        nonceStr: data.nonceStr, //动态获取初始化请求中返回的pay_info参数中nonceStr值
        package: data.packageValue, //动态获取初始化请求中返回的pay_info参数中package值
        signType: data.signType, //动态获取初始化请求中返回的pay_info参数中signType值
        paySign: data.paySign,
      },

      function (res: any) {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          resolve({ code: 200, msg: '支付成功' });
        } else {
          resolve({ code: 500, msg: '支付失败' });
        }
      }
    );
  });
}

/// 支付类型
export class PayType {
  /// HWC公众号支付
  static gatherPayJsWechat = 'gatherPayJsWechat';
  /// 官方公众号支付
  static WECHATJSPAY = 'wechatJsPay';
  // 瑞生意支付 第四方 微信支付
  static gmeJsPay = 'gmeJsPay';
  // 支付宝支付
  static ALIPAY = 'alipay';
  // 金瑞达微信支付
  static JSDH5WX = 'jsd_h5_wx';
  static JSDH5ALI = 'jsd_h5_ali';
  static YHALIWEB = 'yh_ali_web';
  static YHWXWEB = 'yh_wx_web';
  // 龙付通
  static LFT = 'lft';
  static typeStr(type?: string) {
    if (type === PayType.gatherPayJsWechat || type === PayType.WECHATJSPAY || type === PayType.gmeJsPay || type === PayType.LFT || type === PayType.YHWXWEB) {
      return '微信支付';
    }
    return '';
  }

  static typeIcon(type?: string) {
    if (type === PayType.WECHATJSPAY) {
      return 'icon_pay_wx.png';
    } else if (type === PayType.ALIPAY) {
      return 'icon_pay_aili.png';
    } else if (type === PayType.JSDH5WX || type === PayType.YHWXWEB || type === PayType.YHWXWEB) {
      return 'icon_pay_wx.png';
    } else if (type === PayType.JSDH5ALI || type === PayType.YHALIWEB) {
      return 'icon_pay_aili.png';
    } else if (type === PayType.LFT) {
      return 'icon_pay_wx.png';
    }
    return 'icon_pay_bank.png';
  }
}
